import { CheckboxProps as MuiCheckboxProps } from '@mui/material';
import { Checkbox } from './Checkbox';
import {
  InputControlLabelProps,
  InputControlWithLabel
} from '../input-control-with-label/InputControlWithLabel';

export interface CheckboxWrapperProps extends Omit<InputControlLabelProps, 'control'> {
  checkboxProps?: MuiCheckboxProps;
}

export function CheckboxWrapper(props: CheckboxWrapperProps) {
  const { dataId, disabled, checkboxProps, ...inputControlLabelProps } = props;

  return (
    <InputControlWithLabel
      dataId={dataId}
      disabled={disabled}
      {...inputControlLabelProps}
      control={<Checkbox id={dataId} dataId={dataId} disabled={disabled} {...checkboxProps} />}
    />
  );
}
